<template>
    <InsuranceBadgeBase v-bind="badgeProps" />
</template>

<script setup lang="ts">
import { BASE_INSURANCE_BADGE_MAP } from '@/components/shared/InsuranceBadge';
import { Insurance } from '@/types/closinglock.types.js';
import type { DsBadgeProps } from '@ds/badge/DsBadge.vue';
import { computed } from 'vue';
import InsuranceBadgeBase from './InsuranceBadgeBase.vue';

type BadgeContext = 'default' | 'report';

const props = withDefaults(
    defineProps<{
        insurance: Insurance;
        context?: BadgeContext;
    }>(),
    {
        context: 'default',
    },
);

const contextConfig: Record<BadgeContext, Partial<Record<Insurance, Partial<DsBadgeProps>>>> = {
    report: {
        [Insurance.INSURANCE_INSURED]: { text: 'Insured by Closinglock' },
        [Insurance.INSURANCE_ACTION_REQUIRED]: {
            text: 'Pending',
            variant: 'warning',
            icon: 'fa-solid fa-shield-exclamation',
        },
    },
    default: {
        [Insurance.INSURANCE_ACTION_REQUIRED]: {
            text: 'Not insured (IDV)',
            tooltipText: 'Needs identity verification',
        },
    },
};

const badgeProps = computed<DsBadgeProps>(() => {
    const baseProps = BASE_INSURANCE_BADGE_MAP[props.insurance] ?? BASE_INSURANCE_BADGE_MAP[Insurance.INSURANCE_NOT_INSURED];

    const contextProps = contextConfig[props.context]?.[props.insurance] ?? {};

    return { ...baseProps, ...contextProps };
});
</script>
